import { render, staticRenderFns } from "./GlobalSettingsDatatable.vue?vue&type=template&id=308ebcd8"
import script from "./GlobalSettingsDatatable.vue?vue&type=script&lang=js"
export * from "./GlobalSettingsDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports